import type { WebsiteHeaderPhotoSchema_PhotoSlider_v1_1_1 } from '@shared/types/WebsiteHeaderSettings.types';

export const PHOTO_SLIDER_v1_1_1: WebsiteHeaderPhotoSchema_PhotoSlider_v1_1_1 = {
  $id: 'https://withjoy.com/assets/public/websiteHeaderSchemas/photoSlider-v1_1_1.json',
  presentationLayout: 'photoSlider',
  photos: [],
};
